module.exports = __webpack_public_path__ + "static/media/fruits_22.1c070f7c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_22.csv
// module id = 687
// module chunks = 0